import { createStyles, Theme } from '@material-ui/core/styles';

const styles = ({ colors, spacing }: Theme) => createStyles({
  root: {
    width: spacing(47),
    display: 'inline-flex',
    alignItems: 'center',
    border: '2px solid',
    padding: spacing(3),
    boxSizing: 'border-box',
    borderRadius: colors.pageElements.accountType.corner,
    borderColor: colors.pageElements.accountType.enabled.stroke,
    backgroundColor: colors.pageElements.accountType.enabled.fill,
    color: colors.pageElements.accountType.enabled.name,

    '&:hover': {
      borderColor: colors.pageElements.accountType.hovered.stroke,
      backgroundColor: colors.pageElements.accountType.hovered.fill,
      color: colors.pageElements.accountType.hovered.name,
      cursor: 'pointer',
    },
  },
  selected: {
    borderColor: colors.pageElements.accountType.selected.stroke,
    backgroundColor: colors.pageElements.accountType.selected.fill,
    color: colors.pageElements.accountType.selected.name,
    pointerEvents: 'none',
  },
  disabled: {
    borderColor: colors.pageElements.accountType.disabled.stroke,
    backgroundColor: colors.pageElements.accountType.disabled.fill,
    color: colors.pageElements.accountType.disabled.name,
    pointerEvents: 'none',
  },
  title: {
    marginLeft: spacing(2),
  },
});

export default styles;
